import React from "react";
import { buildPatientSummary } from "../../utils/assessmentHistory";

interface CaseLogPanelProps {
  formData: Record<string, string>;
  onReset: () => void;
  onSave: () => void;
}

export const CaseLogPanel: React.FC<CaseLogPanelProps> = ({
  formData,
  onReset,
  onSave,
}) => {
  const patientName = buildPatientSummary(formData);

  return (
    <div className="h-full bg-blue-700 text-white flex flex-col">
      <div className="p-4 border-b border-blue-600">
        <h2 className="font-bold text-base">MDT Case Log</h2>
      </div>
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-2">
          <div className="bg-blue-600 rounded-lg p-3 text-sm">
            <div className="font-medium text-white truncate">{patientName}</div>
            <div className="text-blue-200 text-xs mt-0.5">Current session</div>
          </div>
        </div>
      </div>
      <div className="p-4 border-t border-blue-600 space-y-2">
        <button
          onClick={onSave}
          className="w-full bg-white text-blue-700 font-semibold text-sm py-2 px-3 rounded-lg hover:bg-blue-50 transition-colors flex items-center justify-center gap-2"
        >
          <span>←</span> Save
        </button>
        <button
          onClick={onReset}
          className="w-full bg-blue-600 text-white font-medium text-sm py-2 px-3 rounded-lg hover:bg-blue-500 transition-colors"
        >
          Reset
        </button>
      </div>
    </div>
  );
};
